/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-formatting-unlink': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M2.24 3.126l.884-.883 2.135 2.133-.884.885L2.24 3.126zM14.738 15.62l.885-.884 2.133 2.135-.884.884-2.134-2.135zM6.875 1.25h1.25v2.5h-1.25v-2.5zM1.25 6.875h2.5v1.25h-2.5v-1.25zm15 5h2.5v1.25h-2.5v-1.25zm-4.375 4.375h1.25v2.5h-1.25v-2.5zm-1.512-3.081l-2.32 2.325a2.501 2.501 0 01-3.537-3.538l2.325-2.325-.887-.881-2.319 2.325a3.75 3.75 0 00-.038 5.338A3.75 3.75 0 006.25 17.5a3.794 3.794 0 002.7-1.125l2.3-2.319-.887-.887zM9.63 6.83l2.325-2.325a2.501 2.501 0 113.538 3.538l-2.325 2.325.887.881 2.319-2.325a3.75 3.75 0 00.038-5.338A3.75 3.75 0 0013.75 2.5a3.794 3.794 0 00-2.7 1.125l-2.3 2.319.881.887z"/>'
  }
})
